






































































import Vue from "vue";
import ApiSearchPage from "@/components/apiSearch/components/ApiSearchPage.vue";
import { ApiSearchColumn, ColumnType } from "@/components/apiSearch/models/ApiSearch";
import IconButton from "@/components/IconButton.vue";
import eventBus from "@/services/eventBus";

import store, { MetRiportStore } from "../services/MetRiportStore";
import MetRiportExportItem from "../models/MetRiportExportItem";
import moneyFormat from "@/filters/money-format";
import { t } from "@/plugins/i18n";

interface Data {
    store: MetRiportStore;
    loading: boolean;
}

interface Methods {
    updateItem(item: MetRiportExportItem): void;
}

interface Computed {
    columns: ApiSearchColumn[];
    url: string;
}

export default Vue.extend<Data, Methods, Computed, {}>({
    components: {
        ApiSearchPage,
        IconButton
    },

    async beforeMount() {
        this.loading = true;
        await store.loadItemTypes();
        this.loading = false;
    },

    data() {
        return {
            store,
            loading: false,
        };
    },

    methods: {
        updateItem(item: MetRiportExportItem): void {
            item.inEdit = true;
            store.updateMetRiportExportItem(item).then(r => eventBus.$emit('refreshMetRiportExportItems'));
        }
    },

    computed: {
        url() {
            return `met-riport/export/${this.store.metRiportExportHead.id}/items/search`;
        },
        columns: function() {
            return [
                {
                    field: "id",
                    title: "",
                    cell: 'command',
                    filterable: false,
                    sortable: false,
                },
                {
                    field: "metRiportItemName",
                    title: t("TetelNeve"),
                },
                {
                    field: "metType",
                    title: t("MetisRiport_MetisTipusa"),
                    cell: "metType",
                    multiselect: true,
                    multiselectField: "selectedMetisTypes",
                    multiselectOptions: store.itemTypes.map((x) => ({
                        text: x.name,
                        value: x.id,
                    })),
                },
                {
                    field: "metisCode",
                    title: t("MetisRiport_MetisKod"),
                },
                {
                    field: "notPcCode",
                    title: t("MetisRiport_DMSKodNelkul"),
                    cell: "notPcCode",
                },
                {
                    field: "dmsCode",
                    title: t("MetisRiport_DMSKod"),
                    type: ColumnType.Right
                },
                {
                    field: "calcWithDefault",
                    title: t("MetisRiport_AlapertErtekkelSzamol"),
                    cell: "calcWithDefault",
                },
                {
                    field: "dmsValue",
                    title: t("Ertek"),
                    cell: "dmsValue",
                    type: ColumnType.Right
                }
            ];
        },
    }
});
